import {
  SCROLL_TO_RESULTADO_ID,
  ScrollableFieldsConfig,
} from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { hasAnySim } from '@mchat-rf/consulta-seguimento/utils-consultaSeguimento'
import { isEmpty } from 'bold-ui'
import { SimNaoEnum } from 'components/form'

import { ConsultaSeguimentoPergunta07Model } from './model-consultaSeguimentoPergunta07'
import { isPergunta07OlharParaAllNao } from './utils-consultaSeguimentoPergunta07'

export const PERGUNTA_07_SCROLL_CONFIG: ScrollableFieldsConfig<ConsultaSeguimentoPergunta07Model> = {
  PERGUNTA_07_HEADER: {
    scrollConditions: [
      {
        if: (value) => !isEmpty(value),
        scrollTo: 'PERGUNTA_07_OLHAR_PARA',
      },
    ],
  },
  PERGUNTA_07_OLHAR_PARA: {
    scrollConditions: [
      {
        if: (value) => isPergunta07OlharParaAllNao(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) => hasAnySim(value),
        scrollTo: 'PERGUNTA_07_APONTA_COM_DEDO',
      },
    ],
    isList: true,
    dependsOn: 'PERGUNTA_07_HEADER',
  },
  PERGUNTA_07_APONTA_COM_DEDO: {
    scrollConditions: [
      {
        if: (value) => value === SimNaoEnum.NAO,
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) => value === SimNaoEnum.SIM,
        scrollTo: 'PERGUNTA_07_APONTA_POR',
      },
    ],
    dependsOn: 'PERGUNTA_07_OLHAR_PARA',
  },
  PERGUNTA_07_APONTA_POR: {
    scrollConditions: [
      {
        if: (value) => !isEmpty(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    dependsOn: 'PERGUNTA_07_APONTA_COM_DEDO',
  },
}
